import React from "react";
import T from "prop-types";
import styled, { withTheme } from "styled-components";
import { media } from "@nested/ui";

const Bottom = ({ colour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 1440 50"
  >
    <path
      fill={colour}
      d="M0,0 L1440,0 C1200,33.3333333 960,50 720,50 C480,50 240,33.3333333 0,0 Z"
    />
  </svg>
);

Bottom.propTypes = {
  colour: T.string,
};

const Top = ({ colour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 1440 50"
  >
    <path
      fill={colour}
      d="M0,50 C240,16.6666667 480,0 720,0 C960,0 1200,16.6666667 1440,50 L0,50 Z"
    />
  </svg>
);

Top.propTypes = {
  colour: T.string,
};

const Wrapper = styled.div`
  z-index: 2;
  position: relative;
  width: 100%;
  height: 25px;
  opacity: ${({ opacity }) => opacity};

  ${media.tablet`
    height: 50px;
  `};

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Swoosh = ({
  position,
  colour,
  children,
  theme,
  opacity,
  shade = "medium",
}) => (
  <Wrapper position={position} colour={colour} opacity={opacity}>
    {position === "top" ? (
      <Top colour={theme.palette[colour][shade]} />
    ) : (
      <Bottom colour={theme.palette[colour][shade]} />
    )}
    {children}
  </Wrapper>
);

Swoosh.propTypes = {
  children: T.node,
  colour: T.string.isRequired,
  opacity: T.number,
  position: T.string,
  theme: T.object,
  shade: T.oneOf(["extraLight", "light", "medium", "dark"]),
};

export default withTheme(Swoosh);
